// OTP configuration
export const OTP_RESEND_TIME = 60;
export const NUMBER_OF_OTP = 6;

// API endpoints
export const INITIATE_VERIFY_EMAIL_OTP_URL = '/v2/profile/register/initiate-verify-email';
export const INITIATE_VERIFY_EMAIL_OTP_NON_PUBLIC_URL = '/v2/profile/initiate-verify-email';
export const INITIATE_VERIFY_MOBILE_PHONE_OTP_URL = '/v2/profile/initiate-verify-mobile-phone';
export const VERIFY_EMAIL_OTP = '/v2/profile/register/verify-email-otp';
export const VERIFY_EMAIL_OTP_NON_PUBLIC_URL = '/v2/profile/verify-email-otp';
export const VERIFY_PHONE_OTP = '/v2/profile/verify-mobile-phone-otp';
export const REGISTER_ENDPOINT = '/v2/profile/register';
export const CG_MAPPING = '/profile/cg-mapping';
export const CG_VALIDATION_LIST = '/v2/profile/cg-validation';

// Time constants (milliseconds)
export const ONE_SEC = 1000;
export const THREE_SEC = 3000;
